import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

export default function CheckedOutStatusName({ status, className }) {
  if (status) {
    const classNames = cn('cp-checked-out-status-name', className);
    return (
      <FormattedMessage id={`checkedout_status_${status.toLowerCase()}`}>
        { (message) => <span className={classNames}>{message}</span> }
      </FormattedMessage>
    );
  }

  return null;
}

CheckedOutStatusName.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string
};




// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutStatusName/CheckedOutStatusName.jsx